import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "128",
  height: "133",
  viewBox: "0 0 128 133",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M61.7086 8.41504C61.7084 3.04676 56.2022 -0.704522 51.3765 2.10059C32.9189 12.8305 7.05145 36.2891 7.05133 71.6455C7.05133 91.0404 13.8025 104.571 23.2261 113.768C32.6251 122.94 44.6165 127.738 55.0338 129.826C64.2319 131.67 61.952 130.742 64.4205 131.053L64.4547 131.057L64.4888 131.059C65.6147 131.123 66.6978 131.154 67.73 131.154C76.6181 131.154 89.9068 128.175 100.995 119.23C112.125 110.251 120.949 95.3293 120.949 71.6455C120.949 52.9432 111.11 40.3782 101.73 33.2227C98.838 31.0167 95.497 31.0029 92.814 32.4678C90.1576 33.9183 88.1794 36.7919 87.8189 40.3105L87.2545 45.8252C86.9362 48.9323 85.3599 51.7249 83.2789 53.2988C81.2402 54.8407 78.7564 55.2076 76.3316 53.6318C71.0403 50.1931 67.3735 44.2853 65.0279 37.9697C62.6865 31.6653 61.7086 25.0796 61.7086 20.4512V8.41504Z",
      fill: "#94A3B8",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M93.3564 103.559C93.3564 123.231 77.474 129.314 67.6514 130.152C64.297 129.73 67.6514 130.898 57.0047 128.767C49.1914 126.012 40.6987 118.937 40.6987 103.559C40.6987 93.8143 46.8567 87.802 51.681 84.9876C53.1568 84.1266 54.8707 85.2106 55.0027 86.9118C55.4209 92.3042 60.608 96.5991 64.1417 92.4991C67.2645 88.8759 68.5763 83.5832 68.5763 80.1972V75.7728C68.5763 73.1054 71.2662 71.3382 73.5645 72.6992C82.1097 77.7596 93.3564 88.1703 93.3564 103.559Z",
      fill: "#F1F5F9"
    }, null, -1)
  ])))
}
export default { render: render }